import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import styles from "../../styles/shared/other-coins-signal/OtherCoinsResult.module.css";
import analyzeImage from "../../asset/Images/analyze-image.png";
import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { analyzeOtherCoins } from "../../redux/analyze-other-coins/otherCoinsAnalyzeSlice";
import useUserData from "../../hooks/useUserData";
import OtherExchangesList from "./OtherExchangesList";

function OtherCoinsResult({ selectedExchange, controllerRef }) {
  const {
    otherCoinsAnalyze: { status, result },
    tradingAssistant: { aiMarketType },
  } = useSelector((state) => state);

  const { email, username } = useUserData();

  const {
    coin_analytics_failed_coins_list: failed = [],
    coin_analytics_success_coins_list: processed = [],
  } = result;

  const isAllProcessed = failed?.length === 0 && processed.length > 0;
  const isFailed = failed?.length > 0;
  const totalCoins = failed?.length + processed.length;

  const [showOtherExchanges, setShowOtherExchanges] = useState(false);

  const dispatch = useDispatch();

  const retryHandler = () => {
    controllerRef.current = new AbortController();
    const { signal } = controllerRef.current;

    if (showOtherExchanges) {
      setShowOtherExchanges(false);
    }

    dispatch(
      analyzeOtherCoins(
        username,
        email,
        aiMarketType,
        failed,
        selectedExchange?.toLowerCase(),
        signal,
      ),
    );
  };

  return (
    <>
      {status === "loading" ? (
        <div className={styles.loader}>
          <Spin />
          Fetching signals...
        </div>
      ) : (
        <div className={styles.result}>
          <LazyLoadImage
            src={analyzeImage}
            alt="analyze-result"
            width="200px"
            height="200px"
            effect="blur"
            wrapperClassName={styles.image}
          />

          <h3 className={styles.title}>
            {status === "error" ? "Something went wrong!" : "Process Status"}
          </h3>

          {isAllProcessed && (
            <p className={styles.resultMessage}>
              Processed successfully.
            </p>
          )}

          {isFailed && status !== "error" && (
            <p className={styles.resultMessage}>
              <span>
                {processed?.length} / {totalCoins}
              </span>{" "}
              completed.
            </p>
          )}
          {isFailed && (
            <div className={styles.actionButtons}>
              <span className={styles.retryBtn} onClick={retryHandler}>
                Retry on the current exchange
              </span>
              <span
                className={styles.exchangeBtn}
                onClick={() => setShowOtherExchanges(true)}
              >
                Choose other exchange
              </span>
            </div>
          )}
        </div>
      )}

      {showOtherExchanges && (
        <OtherExchangesList currentExchange={selectedExchange} controllerRef={controllerRef} setShowExchanges={setShowOtherExchanges} />
      )}
    </>
  );
}

export default OtherCoinsResult;
